import { Nullable } from "@gemma/typescript-types";
import Vue from "vue";
import { VueSlideoutEventData } from "./VueSlideoutEventData";

export class VueSlideoutEvent<TData = undefined> extends CustomEvent<VueSlideoutEventData<TData>> {
  constructor(name: string, target: string | Node, vm: Vue, originalEvent: Nullable<Event>, data?: TData) {
    const eventInitDict: { detail: VueSlideoutEventData<TData> } = { detail: { target, vm, originalEvent, data } };

    super(name, eventInitDict);
  }
}
